export default __webpack_public_path__ + "static/media/audio.528c1b5f.svg";